import './css/styles.scss';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

function megaMenuInit() {
	const menuToggle = document.querySelector('[data-open-mega-menu]');
	const megaMenu = document.querySelector('.mega-naven');
	const menuText = document.querySelector('.menu-text');

	if (!megaMenu || !menuToggle || !menuText) return;

	menuToggle.addEventListener('click', () => {
		const isOpen = megaMenu.classList.contains('is-open');

		if (isOpen) {
			megaMenu.classList.remove('is-open');
			enableBodyScroll(megaMenu);
			menuToggle.classList.remove('is-open'); // Reset animation
			menuText.textContent = 'Meny'; // Change text back to "Meny"
		} else {
			megaMenu.classList.add('is-open');
			disableBodyScroll(megaMenu);
			menuToggle.classList.add('is-open'); // Start animation
			menuText.textContent = 'Stäng'; // Change text to "Stäng"
		}
	});

	// Close the menu when clicking outside
	megaMenu.addEventListener('click', (event) => {
		if (!event.target.closest('.inner') && megaMenu.classList.contains('is-open')) {
			megaMenu.classList.remove('is-open');
			enableBodyScroll(megaMenu);
		}
	});

};


document.addEventListener('DOMContentLoaded', function () {
	megaMenuInit();
});
